// extracted by mini-css-extract-plugin
export default {"button":"button--rOVyF","text":"text--lJ0ou","iconWrapper":"iconWrapper--BfhZR","invalid":"invalid--GO0EX"};